import React, { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { toast } from '@warp-ds/elements';
import { Expandable } from '@warp-ds/react';
import { PriceInfo, PriceInfoForMotor } from '../../../../types';
import axiosClient from '../../axiosClient';
import PriceTable from '../PriceTable';
import MotorPriceCalculator from './MotorPriceCalculator';

type MotorPriceInfoProps = {
  orgId: number | undefined,
  valereUnleash: boolean,
};

const toPriceInfoForMotor = (priceInfo: PriceInfo): PriceInfoForMotor | undefined => {
  const motorVertical = priceInfo.verticals.find((v) => v.heading === 'Motor');
  const calculatorGroup = motorVertical?.groupings.find((e) => e.heading === 'Leasingbil, bruktbil og nybil');
  return motorVertical && calculatorGroup ? {
    groups: motorVertical.groupings.filter((e) => e.heading !== 'Leasingbil, bruktbil og nybil'),
    calculatorGroup,
  } : undefined;
};

export default function MotorPriceInfo({ orgId, valereUnleash }: MotorPriceInfoProps) {
  const [priceInfo, setPriceInfo] = useState<PriceInfoForMotor>();

  async function fetchPriceData(): Promise<AxiosResponse<PriceInfo>> {
    return axiosClient.get('api/prices', {
      params: {
        orgId,
        market: 'MOTOR',
      },
    });
  }

  useEffect(() => {
    fetchPriceData()
      .then((result: AxiosResponse<PriceInfo>) => {
        const priceInfoForMotor = toPriceInfoForMotor(result.data);
        setPriceInfo(priceInfoForMotor);
      })
      .catch(() => {
        toast('Vi har problemer med å hente prisinformasjon akkurat nå. Vennligst prøv igjen senere', { type: 'error' });
      });
  }, []);

  return priceInfo ? (
    <div>
      <h2 className="mt-16">Motor</h2>
      { valereUnleash ? (
        <Expandable
          title="Leasingbil, bruktbil og nybil"
          box
          animated
          buttonClass="w-full grow"
        >
          <a href="https://www.finn.no/bedriftskunde/motor/prismodell-bilannonser">Les mer om annonsepakker for bil samt priser per pakke her</a>
        </Expandable>
      ) : (
        <MotorPriceCalculator numberOfPublishedAds={orgId !== undefined ? priceInfo.calculatorGroup?.numberOfPublishedAds : undefined} />
      )}
      { priceInfo.groups.map((group) => (
        <PriceTable
          key={group.heading}
          group={group}
          startOpen={false}
        />
      ))}
    </div>
  ) : <div className="h-[54] s-bg-subtle my-32 rounded-8" />;
}
